export default __webpack_public_path__ + "static/media/3030.4200285a.jpg";